import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { AutoRentalData, FaqData, ProductData } from "@silvertours/front-entities";
import { useStructuredData } from "./useStructuredData";
export var StructuredDataWidget = function(param) {
    var page = param.page, products = param.products;
    var ref = useStructuredData(products, page), faqs = ref.faqs, name = ref.name;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(AutoRentalData, {}),
            /*#__PURE__*/ _jsx(ProductData, {
                products: products
            }),
            faqs && faqs.length > 0 && /*#__PURE__*/ _jsx(FaqData, {
                faqs: faqs,
                name: name
            })
        ]
    });
};
